import HelperService from "../services/helper-service";
import Section from "./section";

export default function Loading({className, ...props}) {
  return (
    <>
      <Section animation={HelperService.getRandomAnimation()} className={`text-center ${className}`}>
        <div style={{width:"60px", height:"60px"}} className={'pulsing bg-white p-1 rounded rounded-circle p-2 align-items-center text-center shadow d-inline-block'}>
          <img style={{width:"80%"}} src="/images/logo-sm-blue.png" alt="načítavam..." />
        </div>
      </Section>
    </>
  );
}
